import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/cancel.png'
import _imports_1 from '@/assets/image/icon/search2.png'


const _withScopeId = n => (_pushScopeId("data-v-a4acde86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "tabs-header" }
const _hoisted_3 = { class: "search" }

import { ref, reactive, onMounted, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import { Field, Toast } from 'vant'
import MTabbar from '@/components/MTabbar/MTabbar.vue'
import MessageList from './components/MessageList/MessageList.vue'
import TalkList from './components/TalkList/TalkList.vue'
import MTabsSwipe from '@/views/components/MTabsSwipe/MTabsSwipe.vue'
import MTaskTime from '@/components/MTaskTime/MTaskTime.vue'
import { RESOURCE_TABS } from '@/constant'


const __default__ = {
  name: 'popular-articles',
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()

const MessageListRef = ref(null)
const TalkListRef = ref(null)
const state = reactive({
  pageType: 1, // 1: 资讯  2: 话题
  searchValue: '',
  isSearch: false,
  tabsActive: 0,
})

onMounted(() => {
  const { pageType } = route.query
  if (pageType) {
    state.pageType = Number(pageType)
  }
})

const handleTabSwiperChange = (index) => {
  state.searchValue = ''
  if (index === 0) {
    state.pageType = 1
  } else {
    state.pageType = 2
  }
}
const handleSearch = () => {
  if (!state.searchValue) return Toast('请输入内容')
  state.isSearch = !state.isSearch
  if (state.pageType === 1) {
    MessageListRef.value.handleSearch()
  } else {
    TalkListRef.value.handleSearch()
  }
}
const handleCancel = () => {
  state.searchValue = ''
  state.isSearch = !state.isSearch
  console.log('state.searchValue==>', state.searchValue)
  nextTick(() => {
    if (state.pageType === 1) {
      MessageListRef.value.handleSearch()
    } else {
      TalkListRef.value.handleSearch()
    }
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(MTaskTime, { type: 4 }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(MTabsSwipe, {
          modelValue: state.tabsActive,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.tabsActive) = $event)),
          tabs: _unref(RESOURCE_TABS),
          onChange: handleTabSwiperChange
        }, null, 8, ["modelValue", "tabs"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Field), {
            modelValue: state.searchValue,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.searchValue) = $event)),
            placeholder: "请输入..."
          }, null, 8, ["modelValue"]),
          (state.isSearch)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "search1",
                src: _imports_0,
                onClick: handleCancel
              }))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: "search2",
                src: _imports_1,
                onClick: handleSearch
              }))
        ])
      ]),
      (state.pageType === 1)
        ? (_openBlock(), _createBlock(MessageList, {
            key: 0,
            ref_key: "MessageListRef",
            ref: MessageListRef,
            searchValue: state.searchValue
          }, null, 8, ["searchValue"]))
        : (_openBlock(), _createBlock(TalkList, {
            key: 1,
            ref_key: "TalkListRef",
            ref: TalkListRef,
            searchValue: state.searchValue
          }, null, 8, ["searchValue"]))
    ]),
    _createVNode(MTabbar)
  ], 64))
}
}

})